import { useUserStore } from '@/stores/user'

function redirectIfNotVector() {
  const user = useUserStore()
  if (user.data?.access?.vector !== true)
    window.location.href = import.meta.env.VITE_APP_URL
}

const insuranceVerification = [
  {
    path: '/vector/insurance-verification',
    name: 'vector-insurance-verification-home',
    component: () => import('@/pages/vector/insurance-verification/EntitledProvidersPage.vue'),
    meta: {
      title: 'Insurance Verification',
      resource: 'Vector',
      action: 'read',
      subject: 'VerificationSession',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
]

export default insuranceVerification
